export const VIEWER = '/mainViewerVtp';
export const DEVELOPER = '/mainViewerVtp';
export const LOGIN = '/login';
export const REGISTER = '/register';
export const LANDING = '/';
